import React, { useEffect, useState } from 'react';

import { inject } from 'mobx-react';
import { NewCheckoutPaymentContainer } from '../NewCheckout/Payment/StripePaymentContainer';
import { NewCheckoutContainer } from '../NewCheckout/Components/Container';
import { NewCheckoutTicketsHeader } from '../NewCheckout/Tickets/Header';
import { NewCheckoutPaymentForm } from '../NewCheckout/Payment/PaymentForm';
import { NewCheckoutSummary } from '../NewCheckout/Components/Summary';
import { Spacer, WarningMessage } from 'public/components';
import { Redirect } from 'react-router';
import { Loader } from 'common/lazy';

function toUSDCents(amount) {
  return Math.round(amount * 100);
}

function getParams() {
  const urlSearchParams = new URLSearchParams(window.location.search);
  return Object.fromEntries(urlSearchParams.entries());
}

function PayForParkingTickets({ parking, appSession }) {
  const [paymentIntent, setPaymentIntent] = useState();
  const [redirect, setRedirect] = useState();
  const [loading, setLoading] = useState(false);
  const [rate, setRate] = useState();
  const [formCompleted, setFormCompleted] = useState(false);

  useEffect(() => {
    if (appSession.isLoggedIn()) {
      setLoading(true);
      const params = getParams();

      parking
        .getPaymentIntent(params.ticket_id)
        .then(({ paymentIntent, rate }) => {
          setPaymentIntent(paymentIntent);
          setRate(rate);
          setLoading(false);
        });
    } else {
      setRedirect(
        `/signup?return=${location.pathname}?ticket_id=${getParams().ticket_id}`
      );
    }
  }, []);

  if (redirect) return <Redirect to={redirect} />;
  if (!paymentIntent)
    return (
      <>
        <Spacer size="xl" />
        <Loader inline="centered" active />
        <Spacer size="xl" />
      </>
    );

  const onSubmit = async (stripe, elements) => {
    try {
      setLoading(true);

      const { error } = await stripe.confirmPayment({
        elements,
        confirmParams: {
          return_url: `${location.origin}${location.pathname}?ticket_id=${
            getParams().ticket_id
          }`,
        },
        redirect: 'if_required',
      });

      if (error) {
        throw error;
      }

      await parking.addPayment(getParams().ticket_id, paymentIntent.id);
      setRedirect('/pay-for-parking/completed');

      // if (error) {
      //   throw this.getError(error);
      // }

      // const noWebhooks =
      //   this.state.order.totalAmount === 0 || API_URL.includes('localhost');
      // if (noWebhooks) {
      //   await this.props.orders.confirm({
      //     orderId: this.state.order.id,
      //     paymentIntentId: this.state?.paymentIntent?.id,
      //     saveCard: true,
      //     discountUsageId: this.state.discountUsageId,
      //   });
      // }

      // const response = await this.props.orders.waitComplete(
      //   this.state.order.id,
      //   1,
      //   5,
      //   noWebhooks ? 0 : 2000
      // );
      // this.completeCheckout(response);
    } catch (err) {
      this.onError(err);
    }
  };

  console.log('paymentIntent: ', paymentIntent);
  console.log('rate: ', rate);
  return (
    <NewCheckoutPaymentContainer clientSecret={paymentIntent?.client_secret}>
      {({ stripe, elements }) => (
        <NewCheckoutContainer
          content={
            <div>
              <NewCheckoutTicketsHeader showLogo={false} title="Payment" />

              <WarningMessage
                style={{ marginBottom: '32px' }}
                content="Please pay when returning to your car to leave.
              Once paid, you will have 30 minutes to exit the parking deck before being changed again."
              />

              <NewCheckoutPaymentForm
                onComplete={(complete) => setFormCompleted(complete)}
                onReady={() => {}}
              />
            </div>
          }
          summary={
            <NewCheckoutSummary
              canSubmit={formCompleted}
              onSubmit={() => onSubmit(stripe, elements)}
              step={2}
              hideAddons
              totals={{
                subtotal: toUSDCents(rate?.NetPrice?.Amount || 0),
                tax: toUSDCents(
                  rate?.Price?.Amount - rate?.NetPrice?.Amount || 0
                ),
                ticketCount: rate ? 1 : 0,
                ticketSubtotal: toUSDCents(rate?.NetPrice?.Amount || 0),
                total: toUSDCents(rate?.Price?.Amount || 0),
                fee: 0,
              }}
              loading={loading}
            />
          }
        />
      )}
    </NewCheckoutPaymentContainer>
  );
}

export default inject('parking', 'appSession')(PayForParkingTickets);
